import React, {useState} from 'react';

import {Modal, Text, TextInput} from '../../../react-native-components-in-react/react-native-components-in-react';

import * as MaskFunctions from '@chocostack/maskifier';
import TInput from './TInput';
import ChocoConfig from '../../ChocoConfig';
import Select from "react-select";
import {HexColorPicker} from "react-colorful";
import {GetTextColor} from "../../../../ColorFunctions";
import Slider from "rc-slider";
import 'rc-slider/assets/index.css';

const Input = (props) => {
    const inputRef = React.useRef(null);
    const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
    const [touched, setTouched] = useState(false);
    const [blured, setBlured] = useState(false);

    let inputElement = <div></div>;

    let inputBorder = {...props.inputStyle};

    if (touched) {
        //inputBorder = { borderBottomWidth: 1, borderBottomColor: 'blue', ...props.inputStyle, ...props.inputStyleTouched };
    }

    if (blured) {
        //inputBorder = { borderBottomWidth: 1, borderBottomColor: 'purple', ...props.inputStyle, ...props.inputStyleBlured };
    }

    let inputStyle = {...inputBorder};

    const onFocus = () => {
        if (!touched) {
            setBlured(false);
            setTouched(true);
        }
    }

    const onBlur = () => {
        if (touched) {
            setTouched(false);
            setBlured(true);
        }
    }

    switch (props.config.elementType) {
        case 'score':
            const buttonStyle = {
                borderRadius: 4,
                border: '2px solid #cccccc',
                backgroundColor: 'white',
                padding: "6px 15px",
                width: '100%',
                marginBottom: 10
            }

            const selectedButtonStyle = {
                border: '2px solid #f05423',
                backgroundColor: '#f9ddc9',
            }

            inputElement = <div
                className={"row"}
            >
                <div
                    className={'col-md-2'}
                >
                    <button
                        style={
                            props.config.value == 1 ?
                                {
                                    ...buttonStyle,
                                    ...selectedButtonStyle
                                }
                                :
                                {...buttonStyle}
                        }
                        onClick={() => {
                            const event = {
                                value: 1
                            }

                            props.inputChangedHandler(event, props.id);
                        }}
                    >
                        {TInput[ChocoConfig.lang].TERRIBLE}
                    </button>
                </div>
                <div
                    className={'col-md-2'}
                >
                    <button
                        style={
                            props.config.value == 2 ?
                                {
                                    ...buttonStyle,
                                    ...selectedButtonStyle
                                }
                                :
                                {...buttonStyle}
                        }
                        onClick={() => {
                            const event = {
                                value: 2
                            }

                            props.inputChangedHandler(event, props.id);
                        }}
                    >
                        {TInput[ChocoConfig.lang].BAD}
                    </button>
                </div>
                <div
                    className={'col-md-2'}
                >
                    <button
                        style={
                            props.config.value == 3 ?
                                {
                                    ...buttonStyle,
                                    ...selectedButtonStyle
                                }
                                :
                                {...buttonStyle}
                        }
                        onClick={() => {
                            const event = {
                                value: 3
                            }

                            props.inputChangedHandler(event, props.id);
                        }}
                    >
                        {TInput[ChocoConfig.lang].NEUTRAL}
                    </button>
                </div>
                <div
                    className={'col-md-2'}
                >
                    <button
                        style={
                            props.config.value == 4 ?
                                {
                                    ...buttonStyle,
                                    ...selectedButtonStyle
                                }
                                :
                                {...buttonStyle}
                        }
                        onClick={() => {
                            const event = {
                                value: 4
                            }

                            props.inputChangedHandler(event, props.id);
                        }}
                    >
                        {TInput[ChocoConfig.lang].GOOD}
                    </button>
                </div>
                <div
                    className={'col-md-3 col-lg-2'}
                >
                    <button
                        style={
                            props.config.value == 5 ?
                                {
                                    ...buttonStyle,
                                    ...selectedButtonStyle
                                }
                                :
                                {...buttonStyle}
                        }
                        onClick={() => {
                            const event = {
                                value: 5
                            }

                            props.inputChangedHandler(event, props.id);
                        }}
                    >
                        {TInput[ChocoConfig.lang].EXCELLENT}
                    </button>
                </div>
            </div>


            return <div style={{position: 'relative', marginBottom: 15, justifyContent: 'flex-end'}}
                        className={props.className}>
                {props.config.label ? <Text
                    style={{...props.labelStyle}}>{props.config.label}</Text> : null}
                <Text
                    style={{color: '#555555', fontSize: '1.1rem'}}>{TInput[ChocoConfig.lang].SCORE_INSTRUCTIONS}</Text>
                {inputElement}
                <Text style={{color: "red"}}>{props.errorMessage}</Text>
            </div>
        case 'currency':
            inputElement = <TextInput
                ignoreDefaultClassNames={true}
                className={'form-control'}
                ref={inputRef}
                onChangeText={(text) => {
                    const event = {
                        unMaskedValue: MaskFunctions.unMaskMoney(text)
                    }

                    props.inputChangedHandler(event, props.id);
                }}
                onFocus={onFocus} onBlur={onBlur}
                {...props.config.elementConfig}
                style={{fontSize: 20, ...inputStyle}}
                value={MaskFunctions.maskMoney(props.config.value)}
            />
            break;
        case 'time':
            inputElement = <TextInput
                ignoreDefaultClassNames={true}
                className={'form-control'}
                ref={inputRef}
                onChangeText={(text) => {
                    const event = {
                        nativeEvent: {
                            text: text
                        }
                    }
                    event.nativeEvent.text = event.nativeEvent.text.substring(0, 5);
                    props.inputChangedHandler(event, props.id);
                }}
                onFocus={onFocus} onBlur={onBlur}
                {...props.config.elementConfig}
                style={{fontSize: 20, ...inputStyle}}
                value={MaskFunctions.maskTime(props.config.value)}
            />
            break;
        case 'input':
            inputElement = <TextInput
                ignoreDefaultClassNames={true}
                className={'form-control'}
                ref={inputRef}
                type={props.config.elementConfig.secureTextEntry ? 'password' : 'text'}
                onChange={props.inputChangedHandler}
                onFocus={onFocus} onBlur={onBlur}
                {...props.config.elementConfig}
                style={{fontSize: 20, ...inputStyle, ...props.config.style}}
                value={props.config.value}
            />
            break;
        case 'image':
            inputElement = <TextInput
                ignoreDefaultClassNames={true}
                className={'form-control'}
                ref={inputRef}
                type={props.config.elementConfig.secureTextEntry ? 'password' : 'text'}
                onChange={props.inputChangedHandler}
                onFocus={onFocus} onBlur={onBlur}
                {...props.config.elementConfig}
                style={{fontSize: 20, ...inputStyle}}
                value={props.config.value}
            />
            break;
        case 'color':
            return <div style={{position: 'relative', marginBottom: 15, justifyContent: 'flex-end'}}
                        className={props.className}>
                {props.config.label ? <Text
                    style={{...props.labelStyle}}>{props.config.label}</Text> : null}
                <div
                    className={'clickable'}
                    onClick={() => setIsColorPickerOpen(true)}
                    style={{
                        border: '1px solid #DDDDDD',
                        height: 30,
                        backgroundColor: props.config.value,
                        borderRadius: 6
                    }}
                >

                </div>
                <Modal
                    visible={isColorPickerOpen}
                    onRequestClose={() => setIsColorPickerOpen(false)}
                >
                    <HexColorPicker
                        style={{width: '100%'}}
                        color={props.config.value}
                        onChange={(color) => {
                            const ev = {
                                nativeEvent: {
                                    text: color
                                }
                            }

                            if (ev.nativeEvent.text.search('#') === -1) {
                                ev.nativeEvent.text = '#' + ev.nativeEvent.text
                            }

                            props.inputChangedHandler(ev)
                        }}/>
                    <input
                        maxLength={7}
                        onChange={(event) => {
                            const ev = {
                                nativeEvent: {
                                    text: event.target.value
                                }
                            }

                            if (ev.nativeEvent.text.search('#') === -1) {
                                ev.nativeEvent.text = '#' + ev.nativeEvent.text
                            }

                            props.inputChangedHandler(ev)
                        }}
                        value={props.config.value}
                        style={{
                            textAlign: 'center',
                            border: 'none',
                            marginTop: 15,
                            backgroundColor: props.config.value,
                            color: GetTextColor(props.config.value)
                        }}
                    />
                </Modal>
                <Text style={{color: "red"}}>{props.errorMessage}</Text>
            </div>
            break;
        case 'select':
            let selectedOption = props.config.options.find(o => o.value == props.config.value);

            selectedOption = selectedOption ? selectedOption : ''

            let styles = {};

            if (props.config.valuesAreFonts) {
                styles = {
                    control: styles => ({...styles}),
                    // @ts-ignore
                    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                        return {
                            ...styles,
                            fontFamily: data.value
                        };
                    },
                }
            }

            inputElement = <div>
                <Select
                    value={selectedOption}
                    isSearchable={false}
                    options={props.config.options}
                    onChange={async (option) => {
                        props.inputChangedHandler(option, props.id);

                        if (props.config.onChangeCallback)
                            props.config.onChangeCallback(option);
                    }}
                    styles={styles}
                    {...props.config.elementConfig}
                />
            </div>

            return <div style={{position: 'relative', marginBottom: 15, justifyContent: 'flex-end'}}
                        className={props.className}>
                {props.config.label ? <Text
                    style={{...props.labelStyle}}>{props.config.label}</Text> : null}
                {inputElement}
                <Text style={{color: "red"}}>{props.errorMessage}</Text>
            </div>
        case 'slider':

            inputElement = <div>
                <Slider
                    min={props.config.validation.min}
                    max={props.config.validation.max}
                    value={props.config.value}
                    step={props.config.step ? props.config.step : 1}
                    onChange={(value) => {
                        props.inputChangedHandler(value, props.id);
                    }}
                />
            </div>

            return <div style={{position: 'relative', marginBottom: 15, justifyContent: 'flex-end'}}
                        className={props.className}>
                {props.config.label ? <Text
                    style={{...props.labelStyle}}>{props.config.label}</Text> : null}
                {inputElement}
                <Text style={{color: "red"}}>{props.errorMessage}</Text>
            </div>
        case 'checkbox':
            return <div>
                <input
                    ref={inputRef}
                    id={props.config.label} name={props.name} onClick={props.inputChangedHandler} className=""
                       type="checkbox"
                       value={props.config.value} checked={props.config.value}/>
                <label onClick={() => {
                    if (inputRef.current) { // @ts-ignore
                        inputRef.current.click()
                    }
                }} style={{marginLeft: "5px"}}>{props.config.label}</label>
            </div>
        case 'tos':
            inputElement = <div>
                <input name={props.name} onClick={props.inputChangedHandler} className="" type="checkbox"
                       value={props.config.value} checked={props.config.value}/>
                <span style={{marginLeft: "5px"}}
                      dangerouslySetInnerHTML={{__html: TInput[ChocoConfig.lang].TERMS_OF_SERVICE}}></span>
            </div>
            break;
    }

    return (
        <div style={{position: 'relative', marginBottom: 15}} className={props.className}>
            {props.config.label ? <div onClick={() => {
                if (inputRef) { // @ts-ignore
                    inputRef.current.focus()
                }
            }} style={{...props.labelStyle}}>{props.config.label}</div> : null}
            {inputElement}
            <div style={{color: "red"}}>{props.errorMessage}</div>
        </div>
    );
}

export default Input;